import { useState } from "react";
import TvsLogo from "../../assets/images/TvsLogo";
import { LoginConstants } from "../../constants/constants";
import { Alert } from "./Alert";
import { PhoneNumberOtpLoginComponent } from "./PhoneNumberOtpLoginComponent";
import DividerIconForLogin from "../../assets/images/DividerIconForLogin";
import { LoginComponentProps } from "../../mobileResponsive/components/common/LoginComponent";
import TVSMUserLogin from "./TVSMUserLogin";
import MobileResponsivePopupModal from "../MobileResponsivePopupModal";

export interface DecodedToken {
  userType: string;
  firstName: string;
  dealerId: string;
  userId: string;
  baseRoles: any[];
  exp: number;
  aud: string;
  azp: string;
  applications: any[];
  country: string;
  dealerName?: string;
  branches?: string[];
  dealerships?: string[];
}
export const LoginComponent: React.FC<LoginComponentProps> = ({
  loginMethods,
  showPopup,
  onPopupClose,
  style,
  errorMessage,
  selectedLoginMethod,
  setSelectedLoginMethod,
}) => {

  const [alert, setAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  const LoginMethodsArray = [
    "Phone Number and OTP",
    "Employee id and password",
    " Face recognition",
    // "Fingerprint",
  ];
  const selectedLoginMethodContainer =
    "bg-primary flex flex-col items-center py-[2vh] px-0 md:px-4 border rounded-lg ";
  const unSelectedLoginMethodContainer =
    "flex flex-col items-center py-[2vh] cursor-pointer";
  const selectedLoginMethodTextBox =
    "w-[95px] staffListHeader text-center text-whiteColor pt-1 ";
  const unSelectedLoginMethodTextBox = "w-[90px] text4 text-center pt-1 ";

  return (
    <div className="fixed z-0 inset-0 overflow-y-auto ">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-blackColor bg-opacity-50 "></div>
        </div>
        <div
          className="inline-block align-bottom bg-whiteColor  rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:align-middle w-[34vw]"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          {alert ? <Alert alertMsg={alertMsg} setAlert={setAlert} /> : ""}
          <div className="pt-[4vh] md:pb-[2vh]">
            <div className="flex justify-between px-4">
              {loginMethods[0]?.image ? (
                <img
                  src={loginMethods[0]?.image ?? ""}
                  alt=""
                  style={{ height: "22px" }}
                />
              ) : (
                <TvsLogo />
              )}
              <div className="text-primary appName">
                {loginMethods[0]?.appName ?? ""}
              </div>
            </div>
            <div className="flex justify-center  md:my-[2vh]">
              <DividerIconForLogin />
            </div>
            <div className="flex justify-center StaffList font-poppins ">
              {LoginConstants.Login}
            </div>
          </div>
          <PhoneNumberOtpLoginComponent
            selectedLoginMethod={selectedLoginMethod}
            loginMethods={loginMethods}
            buttonPadding={{ padding1: "px-40", padding2: "px-48" }}
          />
          <div className="pt-6">
            {loginMethods.length > 1 && (
              <div className="bg-sideMenubackground flex justify-between px-[2vw] md:py-[2vh]  ">
                {loginMethods.map((data: any, index: number) => {
                  const Icon = data.icon;
                  const color =
                    selectedLoginMethod === data.method ? "white" : "#404040";
                  return (
                    <div
                      className={
                        selectedLoginMethod == data.method
                          ? selectedLoginMethodContainer
                          : unSelectedLoginMethodContainer
                      }
                      onClick={() => {
                        setSelectedLoginMethod(data.method);
                      }}
                    >
                      <Icon color={color} />
                      <div
                        className={
                          selectedLoginMethod == data.method
                            ? selectedLoginMethodTextBox
                            : unSelectedLoginMethodTextBox
                        }
                      >
                        {data.label}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* <TVSMUserLogin
            textStyle="px-6 md:py-[2vh] py-12 whitespace-nowrap"
            buttonPadding="px-36 py-2"
          /> */}
        </div>
        {showPopup && (
          <MobileResponsivePopupModal
            onClose={onPopupClose || (() => {})}
            content={errorMessage}
            style={style}
          />
        )}
      </div>
    </div>
  );
};
